// import "../assets/css/style.css";

import { Link } from "react-router-dom";
const BannerOne = () => {
  return (
    <div
      className="ht__bradcaump__area__home__banner__one"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/home/banner1.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__home__banner__one">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h1>Unlock Smarter Crypto Trading — Anytime, Anywhere</h1>
              <p>
                Take control of your financial future with fast execution,
                real-time market insights, and access to the world’s most
                powerful crypto assets — all on a platform built for traders who
                demand more.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

export default BannerOne;
